var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.5 31.25C35.2922 31.25 33.263 32.0136 31.6611 33.2905L21.6527 27.0353C21.9491 25.6946 21.9491 24.3053 21.6527 22.9646L31.6611 16.7094C33.263 17.9864 35.2922 18.75 37.5 18.75C42.6776 18.75 46.875 14.5526 46.875 9.375C46.875 4.19736 42.6776 0 37.5 0C32.3224 0 28.125 4.19736 28.125 9.375C28.125 10.074 28.2021 10.7549 28.3473 11.4103L18.3389 17.6655C16.737 16.3886 14.7078 15.625 12.5 15.625C7.32236 15.625 3.125 19.8224 3.125 25C3.125 30.1776 7.32236 34.375 12.5 34.375C14.7078 34.375 16.737 33.6114 18.3389 32.3345L28.3473 38.5897C28.1993 39.2581 28.1248 39.9405 28.125 40.625C28.125 45.8026 32.3224 50 37.5 50C42.6776 50 46.875 45.8026 46.875 40.625C46.875 35.4474 42.6776 31.25 37.5 31.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    stroke: "url(#paint0_linear_1_230)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_230",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C7015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAlt);
export default __webpack_public_path__ + "static/media/share-alt.6eb1e52af4aa7fb129376b2d463e739f.svg";
export { ForwardRef as ReactComponent };